<template>
  <div class="panel-body">
    <div>
      <div class="box-current-plan">
        <div class="box-title">
          <div class="title">ご利用中のプラン</div>
        </div>
        <div v-if="currentPlan" class="box-items">
          <div class="left-item">
            <div class="plan-info">
              <span class="name">{{ currentPlan.planName }}</span>
              <span v-if="currentPlan.couponName" class="coupon-label">{{ currentPlan.couponName }}</span>
            </div>
            <div class="plan-time">
              <div>（期間：<span>{{ currentPlan.currentPeriodStart }}</span> ～ <span>{{ currentPlan.currentPeriodEnd }}</span>）</div>
            </div>
          </div>
          <div class="right-item">
            <span v-if="currentPlan.isShowFreeTrialing" class="free-trial-using-label">無料トライアル中</span>
          </div>
        </div>
        <div v-else class="no-current-plan">
          <span v-if="!initialCurrentPlan" class="no-current-plan-label">―</span>
        </div>
      </div>
      <div v-if="currentPlan" class="box-change-plan-link">
        <span class="text--underline change-plan-link" @click.prevent="createCustomerPortalSession()">利用プラン・お支払い方法の変更はこちら</span>
      </div>
    </div>

    <div class="box-request-detail-title">請求明細</div>

    <div class="table-logi-invoices">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="text-center w-130">請求日</th>
            <th class="text-center plan-head">プラン</th>
            <th class="text-center amount-head w-220">請求額（税込）</th>
            <th class="w-150"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!initial && !invoices.length">
            <td :colspan="4" class="text-center bg-danger text-danger"><h5>データが見つかりません。</h5></td>
          </tr>
          <tr v-else v-for="invoice in invoices" :key="invoice.seq">
            <td class="text-center">{{ invoice.invoiceDate }}</td>
            <td class="box-plan">
              <div v-if="isPaymentStatusFailed(invoice)" class="box-pay-failed">
                <span class="pay-status-failed">支払いに失敗しました</span>
              </div>
              <div class="plan-info">
                <span v-if="invoice.planName" class="name">{{ invoice.planName }}</span>
                <span v-if="invoice.couponName" class="coupon-label">{{ invoice.couponName }}</span>
              </div>
              <div class="plan-time">
                <div>（期間：<span>{{ invoice.periodStart }}</span> ～ <span>{{ invoice.periodEnd }}</span>）</div>
              </div>
            </td>
            <td class="text-right">
              <div class="amount">{{ formatAmount(invoice.amountDue) }}</div>
            </td>
            <td class="text-center">
              <button v-if="isPaymentStatusFailed(invoice)" type="button" class="btn btn-receipt-disable w-120" disabled>領収書</button>
              <button v-else type="button" class="btn btn-warning btn-receipt w-120" @click.prevent="viewReceipt(invoice)">領収書</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import WarehouseService from '@/services/warehouseservice'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      invoices: [],
      initial: true,
      currentPlan: null,
      loader: null,
      initialCurrentPlan: true
    }
  },
  created () {
    this.getCurrentPlan()
    this.getInvoices()
  },
  methods: {
    isPaymentStatusFailed (invoice) {
      let payStatus = invoice.payStatus
      let paymentStatusFailed = '1'
      return payStatus === paymentStatusFailed ? 1 : 0
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined') ? '' : `${Util.formatMoney(value)} 円`
    },
    getCurrentPlan () {
      WarehouseService.getCurrentPlan()
        .then(response => {
          this.currentPlan = response.data
          if (this.initialCurrentPlan) {
            this.initialCurrentPlan = false
          }
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    getInvoices () {
      WarehouseService.getLogiInvoices()
        .then(response => {
          this.invoices = response.data
          this.initial = false
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    createCustomerPortalSession () {
      if (this.currentPlan === null) {
        return false
      }

      let logParams = {
        name: eventCode.delivery_requests.usage_plan_management_tab.click_link_change_usage_plan,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      let params = {
        seq: this.currentPlan.logiUsage.seq,
        stripeCustomerId: this.currentPlan.logiUsage.stripeCustomerId
      }

      WarehouseService.createCustomerPortalSession(params)
        .then(response => {
          if (response.data) {
            window.location.href = response.data
          }
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    viewReceipt (invoice) {
      let logParams = {
        name: eventCode.delivery_requests.usage_plan_management_tab.click_receipt_button,
        properties: {
          invoiceDate: invoice.invoiceDate
        }
      }
      EventService.postTrackLog(logParams)

      window.open(invoice.hostedInvoiceUrl, '_blank')
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'usage-plan-management') {
      let logParams = {
        name: eventCode.delivery_requests.usage_plan_management_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/UsagePlanManagement.vue